import React from 'react';
import {
    TextInput,
    DateInput,
    SelectInput,
    Edit,
    TabbedForm,
    FormTab,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    SimpleForm,
} from 'react-admin';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import jwt_decode from 'jwt-decode';
import ErrorBoundary from '../ErrorBoundary';
import QAview from './QAview';

const editStyles = {
    root: { alignItems: 'flex-start' },
};

const shippingReady = [
    {
            id : 'Y',
            name: 'Yes'
    },
    {
            id: 'N',
            name: 'No'
    },
    {
        id: 'Q',
        name: 'Quarantine'
    },
    {
        id: 'O',
        name: 'Orphan'
    },
    {
        id: 'E',
        name: 'Research'
    },
    {
        id: 'R',
        name: 'Reactive'
    }
]


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const PackingEditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} label='Packing List'/>
    </CardActions>
);


const PackingToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

const PackingEdit = props => (
    <ErrorBoundary>  
    <div>
         {
    (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).code : '' )=== 'PLAP' &&
   
    <Edit title='Edit Packing' {...props}  actions={<PackingEditActions/>} >
    <SimpleForm  toolbar={<PackingToolbar />}>
      <Table  style={{ margin: 'auto',  fontSize:'12px',  width:"100%" }} >
                    <TableBody >                 
                        <TableRow >
                            <TableCell align="left"><TextInput source="case_no" label="Case Number" validate={required()}/></TableCell>
                            <TableCell align="left" ><DateInput source="packing_date"  label="Packing Date" validate={required()}/></TableCell>
                        </TableRow>               
                        <TableRow>
                            <TableCell align='left' colSpan={2}><TextInput disabled source="ucn" label="Unit Control Number" validate={required()}/></TableCell>
                        </TableRow>
                        
                        <TableRow > 
                            <TableCell align="left"><DateInput disabled source="bleed_date" label="Bleed Date" validate={required()}/></TableCell>
                            <TableCell align="left"><TextInput disabled source="volume" label="Volume (ml)" validate={required()}/></TableCell>
                        </TableRow>               
                        <TableRow >  
                            <TableCell align="left"><TextInput disabled source="ssn" label="SSN" validate={required()}/></TableCell>         
                            <TableCell align="left"><TextInput disabled source="name" label="Name" /></TableCell>        
                        </TableRow>
                        
                    </TableBody>
                </Table>
   
    {/*
<Edit title='Edit Packing' {...props}  actions={<PackingEditActions/>} >
    <TabbedForm toolbar={<PackingToolbar />}>
            <FormTab label="Packing">
                <Table  style={{ margin: 'auto',  fontSize:'12px',  width:"100%" }} >
                    <TableBody >                 
                        <TableRow >
                            <TableCell align="left"><TextInput source="case_no" label="Case Number" validate={required()}/></TableCell>
                            <TableCell align="left"><TextInput source="ucn" label="Unit Control Number" validate={required()}/></TableCell>
                        </TableRow>               
                        <TableRow > 
                            <TableCell align="left"><DateInput source="bleed_date" label="Bleed Date" validate={required()}/></TableCell>
                            <TableCell align="left"><TextInput source="volume" label="Volume (ml)" validate={required()}/></TableCell>
                        </TableRow>               
                        <TableRow >  
                            <TableCell align="left"><TextInput source="ssn" label="SSN" validate={required()}/></TableCell>         
                            <TableCell align="left"><TextInput disabled source="name" label="Name" /></TableCell>        
                        </TableRow>
                        
                    </TableBody>
                </Table>
            </FormTab>
            <FormTab label="Payment">   
                <Table   style={{ margin: 'auto',  fontSize:'12px',  width:"100%" }}>
                    <TableBody >  
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="payment_mode" label="Payment Mode" /></TableCell>
                            <TableCell align="left"><TextInput source="amount" label="Amount: $ "/></TableCell>
                        </TableRow>
                        
                    </TableBody>
                </Table>
            </FormTab>
            <FormTab label="Test Results">   
                <Table   style={{ margin: 'auto',  fontSize:'12px',  width:"100%" }} >
                    <TableBody >  
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="hbs" label="HBS" /></TableCell>
                            <TableCell align="left"><TextInput source="hcv" label="HCV"/></TableCell>
                        </TableRow>
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="hiv" label="HIV" /></TableCell>
                            <TableCell align="left"><TextInput source="hav_nat" label="HAV NAT"/></TableCell>
                        </TableRow>
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="hbv_nat" label="HBV NAT" /></TableCell>
                            <TableCell align="left"><TextInput source="hcv_nat" label="HCV NAT"/></TableCell>
                        </TableRow>
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="hiv_nat" label="HIV NAT" /></TableCell>
                            <TableCell align="left"><TextInput source="parvo_nat" label="PARVO NAT"/></TableCell>
                        </TableRow>
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="spe" label="SPE" /></TableCell>
                            <TableCell align="left"><TextInput source="rpr" label="RPR"/></TableCell>
                        </TableRow>
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="aby" label="ABY" /></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </FormTab>
            <FormTab label="Management/Other">   
                <Table  style={{ margin: 'auto',  fontSize:'12px',  width:"100%" }} >
                    <TableBody > 
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="mgnt_initial" label="Mgnt Initial" /></TableCell>
                            <TableCell align="left"><DateInput source="mgnt_date" label="Mgnt Date" /></TableCell>
                        </TableRow>
                        <TableRow > 
                            <TableCell align="left" colSpan="2"><TextInput source="comments" label="Comments" style={{width: '40em' }} /></TableCell>
                            
                        </TableRow > 
                        <TableRow >               
                        <TableCell align="left"><TextInput source="qa_initial" label="QA Initial" /></TableCell>        
                            <TableCell align="left"><SelectInput source="ready_to_ship"  choices={shippingReady} label="Ready to Ship?" /></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </FormTab>
        </TabbedForm>
    */}
     </SimpleForm>
    </Edit>
    }

    {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).code : '' )=== 'QA' &&
   
   <Edit title='Edit Packing' {...props}  actions={<PackingEditActions/>} >
   <SimpleForm  toolbar={<PackingToolbar />}>
   <QAview  />
   <Table  style={{ margin: 'auto',  fontSize:'12px',  width:"100%" }} >
        <TableBody > 
            <TableRow>
                <TableCell colSpan={2}></TableCell>
            </TableRow>
            <TableRow >                    
                <TableCell align="left" colSpan="2"><SelectInput source="ready_to_ship"  choices={shippingReady} label="Ready to Ship?" /></TableCell>
            </TableRow>
            <TableRow > 
                <TableCell align="left" colSpan="2"><TextInput source="comments" label="Comments" style={{width: '40em' }} /></TableCell>
            </TableRow > 
            <TableRow >               
                <TableCell align="left"><TextInput source="qa_initial" label="QA Initial" /></TableCell>        
                <TableCell align="left"><DateInput source="qa_date" label="QA Date" /></TableCell>
            </TableRow>
        </TableBody>
    </Table>
   </SimpleForm>
    </Edit>
    }

    {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) >  7  &&
    <Edit title='Edit Packing' {...props}  actions={<PackingEditActions/>} >
    <TabbedForm toolbar={<PackingToolbar />}>
            <FormTab label="Packing">
                <Table  style={{ margin: 'auto',  fontSize:'12px',  width:"100%" }} >
                    <TableBody >                 
                        <TableRow >
                            <TableCell align="left"><TextInput source="case_no" label="Case Number" validate={required()}/></TableCell>
                            <TableCell align="left"><TextInput source="ucn" label="Unit Control Number" validate={required()}/></TableCell>
                        </TableRow>               
                        <TableRow > 
                            <TableCell align="left"><DateInput source="bleed_date" label="Bleed Date" validate={required()}/></TableCell>
                            <TableCell align="left"><TextInput source="volume" label="Volume (ml)" validate={required()}/></TableCell>
                        </TableRow>               
                        <TableRow >  
                            <TableCell align="left"><TextInput source="ssn" label="SSN" validate={required()}/></TableCell>         
                            <TableCell align="left"><TextInput disabled source="name" label="Name" /></TableCell>        
                        </TableRow>
                        
                    </TableBody>
                </Table>
            </FormTab>
            <FormTab label="Payment">   
                <Table   style={{ margin: 'auto',  fontSize:'12px',  width:"100%" }}>
                    <TableBody >  
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="payment_mode" label="Payment Mode" /></TableCell>
                            <TableCell align="left"><TextInput source="amount" label="Amount: $ "/></TableCell>
                        </TableRow>
                        
                    </TableBody>
                </Table>
            </FormTab>
            <FormTab label="Test Results">   
                <Table   style={{ margin: 'auto',  fontSize:'12px',  width:"100%" }} >
                    <TableBody >  
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="hbs" label="HBS" disabled/></TableCell>
                            <TableCell align="left"><TextInput source="hcv" label="HCV" disabled/></TableCell>
                        </TableRow>
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="hiv" label="HIV" disabled/></TableCell>
                            <TableCell align="left"><TextInput source="hav_nat" label="HAV NAT" disabled/></TableCell>
                        </TableRow>
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="hbv_nat" label="HBV NAT" disabled/></TableCell>
                            <TableCell align="left"><TextInput source="hcv_nat" label="HCV NAT" disabled/></TableCell>
                        </TableRow>
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="hiv_nat" label="HIV NAT" disabled/></TableCell>
                            <TableCell align="left"><TextInput source="parvo_nat" label="PARVO NAT" disabled/></TableCell>
                        </TableRow>
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="spe" label="SPE" disabled/></TableCell>
                            <TableCell align="left"><TextInput source="rpr" label="RPR" disabled/></TableCell>
                        </TableRow>
                        <TableRow >                    
                            <TableCell align="left"><TextInput source="aby" label="ABY" disabled/></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </FormTab>
            <FormTab label="QA/Other">   
                <Table  style={{ margin: 'auto',  fontSize:'12px',  width:"100%" }} >
                <TableRow >                    
                    <TableCell align="left" colSpan="2"><SelectInput source="ready_to_ship"  choices={shippingReady} label="Ready to Ship?" /></TableCell>
                </TableRow>
                <TableRow > 
                    <TableCell align="left" colSpan="2"><TextInput source="comments" label="Comments" style={{width: '40em' }} /></TableCell>
                </TableRow > 
                <TableRow >               
                    <TableCell align="left"><TextInput source="qa_initial" label="QA Initial" /></TableCell>        
                    <TableCell align="left"><DateInput source="qa_date" label="QA Date" /></TableCell>
                </TableRow>
                </Table>
            </FormTab>
        </TabbedForm>
    </Edit>
    }
     </div>
     </ErrorBoundary>  
);

export default PackingEdit ;